import "../App.css";

export default function Alert({ message, type = "info", onClose }) {
  const colors = {
    success: "alert-success",
    error: "alert-error",
    warning: "alert-warning",
    info: "alert-info",
  };

  return (
    <div className="alert-overlay">
      <div className={`alert-box ${colors[type]}`}>
        <p>{message}</p>
        <button onClick={onClose}>OK</button>
      </div>
    </div>
  );
}
